import { useContext } from "react";
import {ReactEvent} from "@mathbuddy/adaptive-practice-events";
import { renderedContext } from "../context/context";
import { IConfig } from "./Render";
export const Button = ({className, id, style, children, clickedVal, actualVal,clickable,extraProps}:IConfig)=>
{
    // Shown, not played: see Div.
    const state: any = useContext(renderedContext);

    const onClick = ()=>{
        if (state?.readOnly === true) return;
        // The student has done something to this question - see markTouched in PlayFrame.
        state?.markTouched?.();
        new ReactEvent({id,clickedVal,actualVal,extraProps}).handleEvent(extraProps.event);
    }

    return (
        
        <button id={id} style={style} onClick ={()=>onClick()} className={className}>{children}</button>
    );

}